"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StatCoverageTypes;
(function (StatCoverageTypes) {
    StatCoverageTypes["minimum"] = "minimum";
    StatCoverageTypes["standard"] = "standard";
})(StatCoverageTypes = exports.StatCoverageTypes || (exports.StatCoverageTypes = {}));
//# sourceMappingURL=RectangleMatchConfig.js.map